import React from "react"

import NameList from "./NameList"
import { PromptWithResponses } from "./types"

type PromptAnswersProps = {
  prompt: PromptWithResponses
  presentStudents?: { fullName: string; id: string }[]
}

const PromptAnswers = ({ prompt, presentStudents }: PromptAnswersProps) => {
  const answeredIds = prompt.responses.map(response => response.student.id)
  const unansweredNames = (presentStudents ?? [])
    .filter(student => !answeredIds.includes(student.id))
    .map(student => student.fullName)

  const yesNames = prompt.responses
    .filter(response => response.answer === "yes")
    .map(response => response.student.fullName)
  const noNames = prompt.responses
    .filter(response => response.answer === "no")
    .map(response => response.student.fullName)

  return prompt.answerType === "yesNo" ? (
    <div
      className={`grid gap-3 ${
        presentStudents ? "sm:grid-cols-3" : "sm:grid-cols-2"
      }`}
    >
      <NameList
        heading={`Yes (${yesNames.length})`}
        headingClassNames={yesNames.length > 0 && "text-green-300"}
        names={yesNames}
      />
      <NameList
        heading={`No (${noNames.length})`}
        headingClassNames={noNames.length > 0 && "text-green-300"}
        names={noNames}
      />
      <NameList
        heading={`Unanswered (${unansweredNames.length})`}
        headingClassNames={unansweredNames.length > 0 && "text-red-400"}
        names={unansweredNames}
      />
    </div>
  ) : (
    <div className="space-y-3">
      {prompt.responses.map(response => (
        <div
          key={response.id}
          className="rounded-lg bg-neutral-900 p-3 text-sm"
        >
          <p className="font-semibold">{response.student.fullName}</p>
          <p className="mt-1 whitespace-pre-wrap text-white">
            {response.answer}
          </p>
        </div>
      ))}
      <NameList
        heading={`Unanswered (${unansweredNames.length})`}
        headingClassNames={unansweredNames.length > 0 && "text-red-400"}
        names={unansweredNames}
      />
    </div>
  )
}

export default PromptAnswers
